import { Spinner } from 'ui/spinner';
import { useTemplatePreview, useTemplatePreviewContext } from '../hooks';

export const CampaignTemplatePreview = () => {
  const PreviewContext = useTemplatePreviewContext();
  const LoadPreview = useTemplatePreview();

  const isLoading = !PreviewContext || !LoadPreview;

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <PreviewContext>
          <LoadPreview />
        </PreviewContext>
      )}
    </>
  );
};
